<template>
  <Table>
    <template #columns>
      <th
        v-for="(column, index) in studentColumns"
        :key="index"
        scope="col"
        class="px-2 py-3 text-left text-xs text-gray-500 uppercase tracking-wider"
      >
        {{ column }}
      </th>
    </template>
    <template #rows>
      <tr v-if="!students">
        <td width="25%">
        </td>
        <td width="50%">
          <Spinner class="py-4"
            message="Loading Students"
            :size="8"
          />
        </td>
        <td width="25%">
        </td>
      </tr>
      <tr v-for="student in students" :key="student.internalId">
        <td class="px-2 py-2 whitespace-nowrap">
          <div class="text-sm text-gray-900">
            {{ student.internalId }}
          </div>
        </td>
        <td class="px-2 py-2 whitespace-nowrap">
          <div class="text-sm text-gray-900">
            {{ `${student.firstName} ${student.lastName}` }}
          </div>
        </td>
        <td class="px-2 py-2 whitespace-nowrap">
          <div class="text-sm text-gray-900">
            {{ studentStatusDisplay(student) }}
          </div>
        </td>
        <td class="px-2 py-1 whitespace-nowrap">
          <div class="flex gap-1 flex-wrap w-full place-content-between">
            <div class="flex gap-1 flex-wrap">
              <Tag
                class="place-content-center"
                v-for="accommodation in accommodations.filter(
                  accommodation =>
                    student.accommodations[accommodation.name]
                )"
                :key="accommodation.name"
                :backgroundColor="accommodation.backgroundColor"
                :textColor="accommodation.textColor ? accommodation.textColor : 'black'"
              >
                {{ accommodation.text }}
              </Tag>
            </div>
            <div class="flex flex-row">
              <button
                class="border text-md px-3 py-2 bg-gray-50 transition-colors duration-300 rounded-l-md shadow-sm disabled:bg-gray-200 hover:bg-gray-100"
                @click="studentDetailOpen(student.internalId)">
                Go To
              </button>
              <button
                class="border text-md px-3 py-2 bg-gray-50 transition-colors duration-300 rounded-r-md shadow-sm disabled:bg-gray-200 hover:bg-gray-100"
                @click="studentDetailNewWindow(student.internalId)">
                New Window
              </button>
            </div>
          </div>
        </td>
      </tr>
    </template>
  </Table>
</template>

<script>
import Table from '../Table.vue'
import Tag from '../Tag.vue'
import Spinner from '../Spinner.vue'

export default {
  components: {
    Table,
    Tag,
    Spinner,
  },
  props: {
    students: Array,
  },
  data() {
    return {
      accommodations: [
        {
          name: 'aide',
          text: 'Aide',
          backgroundColor: '#FCA5A5'
        },
        {
          name: 'solo',
          text: 'Solo',
          backgroundColor: '#FC0000',
          textColor: 'white',
        },
        {
          name: 'wheelchair',
          text: 'Wheelchair',
          backgroundColor: '#FCD34D'
        },
        {
          name: 'boosterSeat',
          text: 'Booster seat',
          backgroundColor: '#6EE7B7'
        },
        {
          name: 'safetyVest',
          text: 'Safety vest',
          backgroundColor: '#93C5FD'
        },
        {
          name: 'safetyBeltLockingCover',
          text: 'Safety belt locking cover',
          backgroundColor: '#A5B4FC'
        },
        {
          name: 'carSeat',
          text: 'Car seat',
          backgroundColor: '#C4B5FD'
        }
      ],
      studentColumns: ['Internal ID', 'Name', 'Status', 'Accommodations'],
      STATUS_DISPLAY_MAP: {
        off: 'Off',
        riding: 'Riding',
      },
    }
  },
  methods: {
    studentStatusDisplay(student) {
      if (student.noRide) {
        return 'No Ride'
      }
      if (student.status) {
        return this.STATUS_DISPLAY_MAP[student.status] || 'Unknown'
      }
      return 'Unknown'
    },
    studentDetailOpen(internalId) {
      let dbId = this.students[this.students.findIndex(e => e.internalId == internalId)].dbId
      if (this.selected < 0) {
        return
      }
      // this.$route.params.dbId can actually be a string, so it needs to be double equals
      if (this.$route.name === 'StudentHistory' && this.$route.params.dbId == dbId) {
        return
      }
      this.$router.push({
        name: 'StudentHistory',
        params: {
          studentDbId: dbId
        }
      })
    },
    studentDetailNewWindow(internalId) {
      let dbId = this.students[this.students.findIndex(e => e.internalId == internalId)].dbId
      if (this.selected < 0) {
        return
      }
      const routeData = this.$router.resolve({
        name: 'StudentHistory',
        params: {
          studentDbId: dbId
        }
      })
      console.log(routeData.href)
      window.open(routeData.href, '_blank')
    },
  }
}
</script>
